import '@xyflow/react/dist/style.css';
import './style.css';
import useWorkflowStore from './store';
import {Resizable} from 're-resizable';
import {useState} from 'react';

export const TimelineMarkers = () => {
  const {viewport, timelineMarkers, setTimelineMarkers, takeSnapshot} = useWorkflowStore();

  // Save timeline marker positions and widths before resizing
  const [markerResizing, setMarkerResizing] = useState<any>(undefined);

  return (
    <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
      {timelineMarkers.map((marker, index) => (
        <Resizable
          className="flex items-center justify-center"
          key={marker.id}
          size={{width: marker.width * viewport.zoom, height: '100%'}}
          enable={{top: false, right: true, bottom: false, left: false}}
          onResizeStart={() => {
            // save current position and height of swimlanes
            const ms = {};
            for (const m of timelineMarkers) {
              ms[m.id] = {x0: m.x, w0: m.width};
            }
            setMarkerResizing(ms);
            console.log('onResizeStart', ms);
          }}
          onResize={(e, direction, ref, d) => {
            const deltaW = d.width / viewport.zoom;
            setTimelineMarkers(markers =>
              markers.map(m => {
                if (m.id === marker.id) {
                  return {...m, width: markerResizing[m.id].w0 + deltaW};
                } else if (m.x > marker.x) {
                  return {...m, x: markerResizing[m.id].x0 + deltaW};
                }
                return m;
              }),
            );
          }}
          onResizeStop={() => {
            // Take snapshot after resizing is complete
            takeSnapshot();
          }}
          style={{
            pointerEvents: 'none',
            position: 'absolute',
            top: 0,
            left: viewport.x + marker.x * viewport.zoom,
            zIndex: 40,
            backgroundColor: 'transparent',
            borderLeft: index == 0 ? `${2 * viewport.zoom}px dashed #ccc` : '',
            borderRight: `${2 * viewport.zoom}px dashed #ccc`,
          }}
          handleStyles={{
            right: {
              pointerEvents: 'auto',
            },
          }}>
          <span
            style={{
              position: 'absolute',
              top: 10 * viewport.zoom,
              left: 10 * viewport.zoom,
              fontSize: 14 * viewport.zoom,
              fontWeight: 'bold',
            }}>
            {marker.label}
          </span>
        </Resizable>
      ))}
    </div>
  );
};
